import { MeditatorTabs, TableTitles } from "@/constants"
import { useGetMeditationRetreatByLevels } from "@/hooks/query-hooks/useMeditationRetreats"
import { Button } from "antd"
import { useState } from "react"
import { Link, useLocation } from "react-router"
import { MeditationRetreatsTable } from "./MeditationRetreatsTable"

type Props = {
    levelIds: number[],
    hasFilter?: boolean
}

export function MeditationRetreatsByLevel({
    levelIds,
    hasFilter = true
}: Props) {

    const [page, setPage] = useState(1)
    const { data, isLoading } = useGetMeditationRetreatByLevels(page, levelIds);

    const retreats = data?.content || [];

    const renderColumnsKey = [
        TableTitles.retreat_start_month,
        TableTitles.retreat_level,
        TableTitles.retreat_name,
        TableTitles.retreat_duration,
        TableTitles.retreat_start_date,
        TableTitles.retreat_end_date,
        TableTitles.total_registrants,
        TableTitles.action
    ]

    return (
        <>
            <MeditationRetreatsTable
                dataSource={retreats || []}
                renderColumnKeys={renderColumnsKey}
                TableActionComponent={TableActionComponent}
                hasFilter={hasFilter}
                loading={isLoading}
                pagination={{
                    current: page,
                    total: data?.totalElements || 0,
                    onChange: (page) => setPage(page),
                }}
            />
        </>
    )
}

const TableActionComponent = ({ record }: { record: MeditationRetreat }) => {

    const searchParams = useLocation().search;
    const activeTab = new URLSearchParams(searchParams).get("tab");

    const href = activeTab === MeditatorTabs.new_registrants ? MeditatorTabs.new_registrants : MeditatorTabs.old_registrants;

    return (
        <Link
            to={`/retreat-registrants/${record.id}/${href}`}
        >
            <Button
                type="link"
                size="small"
            >
                View
            </Button>
        </Link>
    )
}